package ui.location.detail

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.staggeredgrid.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.draw.*
import androidx.compose.ui.layout.*
import androidx.compose.ui.unit.*
import api.*
import compose.assets.*
import compose.assets.svg.*
import tools.*
import ui.resource.*
import ui.widget.*

@Composable
fun LocationScope.LocationBrandingPhotos(
    nnvl: LocationScope.Wrapper,
    modifier: Modifier
) {

    val imagePickerKey = remember(args.locationId) {
        "LocationBrandingPhotos:${args.locationId}"
    }

    GlobalObjectShare.Consumer(imagePickerKey)

    Box(modifier) {
        LazyVerticalStaggeredGrid(
            columns = StaggeredGridCells.Adaptive(256.dp),
            modifier = Modifier.fillMaxSize(),
            contentPadding = PaddingValues(8.dp),
            verticalItemSpacing = 8.dp,
            horizontalArrangement = Arrangement.spacedBy(8.dp)
        ) {

            if (nnvl.branding.images.state.isEmpty()) {
                item {
                    ImageEntry(LocationScope.WrapperBrandingImages.Item(-1))
                }
            } else {
                items(nnvl.branding.images.state) { item ->
                    ImageEntry(item) {
                        nnvl.branding.images.removeAll { it.data == item.data }
                    }
                }
            }
        }
        FloatingActionButton(
            onClick = {
                GlobalObjectShare.launchImagePicker(
                    key = imagePickerKey,
                    nav = nav,
                    args = ResourceListingArgs(
                        companyId = nnvl.data.company.id,
                        restrictionType = ResourceType.IMAGE.mask,
                        pickerMode = true,
                        excluded = nnvl.branding.images.state.map { it.data }.joinToString(",")
                    )
                ) {
                    it.forEach { item ->
                        nnvl.branding.images.add(
                            index = 0,
                            newItem = LocationScope.WrapperBrandingImages.Item(item.id)
                        )
                    }
                }
            },
            modifier = Modifier.align(Alignment.BottomEnd)
                .padding(16.dp)
        ) {
            Icon(Svg.Plus, null)
        }
    }
}

@Composable
private fun ImageEntry(
    it: LocationScope.WrapperBrandingImages.Item,
    onDelete: (() -> Unit)? = null
) {
    Box(Modifier.width(256.dp)) {
        LazyImage(it.data, Modifier.fillMaxWidth(), contentScale = ContentScale.Fit, alphaBackground = false)
        onDelete?.also { action ->
            IconButton(
                onClick = { action() },
                colors = IconButtonDefaults.iconButtonColors(
                    containerColor = MaterialTheme.colorScheme.surface,
                ),
                modifier = Modifier.padding(8.dp)
                    .alpha(0.8F)
                    .align(Alignment.TopCenter)
            ) {
                Icon(Svg.DeleteEmpty, null)
            }
        }
    }
}
